const QUOTE_STATUS_COLORS = {
    DRAFT: "secondary",
    SENT_TO_CUSTOMER: "primary",
    CLOSED: "danger",
    CONVERTED_TO_ORDER: "success",
    EXPIRED: "danger"
}

export default QUOTE_STATUS_COLORS;